export default "__VITE_ASSET__PzuyPZL8__"